import {Component, inject, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AuthService} from '../services/AuthService';
import {RegistryService} from '../services/RegistryService';
import {Dialog} from 'primeng/dialog';
import {Button} from 'primeng/button';
import {NetworkService} from '../services/NetworkService';
import {Toast} from 'primeng/toast';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Dialog, Button, Toast, TranslocoPipe],
  template: `
    @if(langloaded()) {
      <p-toast [position]="this.auth.rtl() ? 'top-left': 'top-right'" />
      <router-outlet />
      <p-dialog
        (close)="net.showNetworkError.set(false)"
        header="Network Error"
        [modal]="true"
        [(visible)]="net.showNetworkError"
        [style]="{ width: '25rem' }">
        <h1 class="h-1">{{'Something wrong with network'|transloco}}</h1>
        <div class="flex justify-end gap-2">
          <p-button label="Ok" severity="secondary" (click)="net.showNetworkError.set(false)" />
        </div>
      </p-dialog>
    }
  `
})
export class App {
  public langloaded = signal(false)
  public t = inject(TranslocoService)
  public net = inject(NetworkService)
  public registry = inject(RegistryService)
  public auth = inject(AuthService)
  constructor() {
    if(this.auth.isLoggedIn()) {
      this.registry.loadServices().catch()
    }
    this.t.events$.subscribe(e => {
      if(e.type == "translationLoadSuccess") {
        if(e.payload.langName===this.t.getActiveLang()) {
          this.langloaded.set(true)
        }
      }
    })
    document.documentElement.setAttribute('dir', localStorage.getItem('dir') || 'ltr');
    document.documentElement.setAttribute('lang', localStorage.getItem('lang') || 'en');
  }
}
